import { InjectionToken } from '@angular/core';

export const NOTIFICATION_DATA = new InjectionToken('Notification data');
